import { Component, OnInit } from '@angular/core';
import { Piece } from '../../../inventory/piece';
import { SalesService } from '../../../sales/sales.service';
import { PoService } from '../../../purchasing/pos/po.service';
import { TdDialogService } from '@covalent/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PoBranch } from '../../../purchasing/pos/poBranch';
import { ReceivingService } from '../../../receiving/receiving.service';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { LocationService } from 'services/location.service';
import { Location } from '../../../accounting/location';
import { Sale } from '../../../sales/sale';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { ProductService } from 'app/agatextscreens/purchasing/products/product.service';
import { PrintingService } from 'app/shared/services/printing.service';
import { Product } from 'app/agatextscreens/purchasing/products/product';

@Component({
  selector: 'app-ship-order-items',
  templateUrl: './ship-order-items.component.html',
  styleUrls: ['./ship-order-items.component.scss'],
  providers: [InvoiceService, ProductService, PrintingService]
})
export class ShipOrderItemsComponent implements OnInit {
  id: string;
  order_number: string = '';
  order_items: Piece[] = [];
  grouped_items: { location: string, pieces: Piece[] }[] = [];

  _scanned: string;
  _prepared_location_id: number;

  _invoice_number: string;

  branchLocations: Location[];

  customer_id: number;

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  _notes: string = '';
  _creating: boolean = false;

  constructor(private _salesService: SalesService,
    private _poService: PoService,
    private _receivingService: ReceivingService,
    private _dialogService: TdDialogService,
    private _inventoryService: InventoryService,
    private _locationService: LocationService,
    private _invoiceService: InvoiceService,
    private router: Router,
    private route: ActivatedRoute,
    public _authService: AuthenticationService,
    private _productService: ProductService,
    private _printService: PrintingService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        this._salesService.getSaleItems(this.id + '').subscribe(
          response => {
            this.order_items = response;
            this.groupByLocation();
          }
        );

        this._salesService.getOneSale(this.id).subscribe(
          saleOrder => {
            this._notes = saleOrder.notes;
          }
        )
      }
    );

    this.route.queryParams.subscribe(
      params => {
        this.order_number = params['order_number'];
        this.customer_id = (params['customer_id'] != 'null') ? params['customer_id'] : 0;

        this._locationService.getLocations(params['branch_id']).subscribe(
          response => {
            this.branchLocations = response;
          }
        );
        this._prepared_location_id = params['location_id'];
      }
    );

  }

  groupByLocation() {
    this.order_items.forEach(
      item => {
        let this_group = this.grouped_items.find(i => { return item['location'] == i['location'] });

        if (this_group != null) {
          this_group.pieces.push(item);
        } else {
          this.grouped_items.push({ location: item['location'], pieces: [item] })
        }
      }
    );
    // Order alphabetically
    this.grouped_items.sort((a, b) => { return (a.location > b.location) ? 1 : -1 })
  }

  markScanned(_scanned: string): void {
    if (_scanned == null && _scanned == '') {
      return;
    }

    let location: Location = this.getFullLocation();

    console.log(location);
    console.log(this.order_items);
    if (!location) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The scanned location is not a valid location in the Order\'s sourcing branch'
      });
      return;
    }

    /*if (location.id != this._prepared_location_id) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The scanned location is not the same as the location where this Order was prepared'
      });
      return;
    }*/

    this.order_items.forEach( 
      (i) => {
        // Mark selected the items for this SKID
        console.log(location.id == i.prepared_location_id)

        if (location.id == i.prepared_location_id) {

          if (i.sold || i.deleted) {
            this._dialogService.openAlert({
              message: 'Some pieces are no longer available. Send back to preparing to swap them, or ship without the missing pieces',
              title: 'Warning'
            });
          } else {
            i['checked'] = true;
          }
          
        }
      }
    );

    // Clean up after marking
    this._scanned = '';
  }

  allItemsChecked() {
    return (this.order_items.length - this.order_items.reduce((a, b) => { return a + (b['checked'] ? 1 : 0) }, 0)) == 0
  }

  getFullLocation(): Location {
    return (this.branchLocations.find((l: Location) => { return l.name == this._scanned }));
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      let len = this.transaction_status.length;

      this._dialogService.openAlert(
        {
          title: 'Result',
          // if longer than 10 only show the first 10
          message: this.transaction_status.slice(0, 10).join(', ') +
            (len > 10 ? '... and ' + (len - 10) + ' more' : '')
        }
      ).afterClosed().subscribe(
        result => {
          this.router.navigate(['/pda', 'shipping', 'shipOrder']);
        });
    }
  }

  shipOrder() {
    //not used anywhere?
    //let doAnyways: boolean = false;

    this._creating = true;

    if (!this._invoice_number) {
      this._dialogService.openAlert({
        title: 'Verify the information',
        message: 'The invoice Number is mandatory',
      });
      this._creating = false;
      return;
    }

    if (!this.allItemsChecked()) {
      this._dialogService.openConfirm({
        title: 'Verify the information',
        message: 'Not all pieces have been scanned. Do you want to mark as shipped anyways?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }).afterClosed().subscribe(
        result => {
          // Yes --> true
          // No --> false
          // Click outside --> Undefined
          if (result) {
            this.doShipOrder();
          }
        }
      );
    } else {
      this.doShipOrder();
    }
  }

  doShipOrder() {
    // We will run one at least
    this.confirmation_length = 1;
    // And two additional if this is B2B
    if (this.customer_id == 0) {
      this.confirmation_length += 2;
    }
    // we also need to mark them as sold
    this.confirmation_length += this.order_items.length;
    // And to insert the invoice in the invoices list after all, if this was not B2B
    if (this.customer_id != 0) {
      this.confirmation_length += 1
    }

    // THIS IS THE REFERENCE TO THE SALE
    let this_sale_order: Sale;

    // Mark the sales order as "SHIPPED"
    this._salesService.getOneSale(this.id).subscribe(
      response => {
        response.status = 'SHIPPED';
        response.delivery_date = (new Date()).toISOString().substr(0, 10);
        delete response.prepared_location_id;

        // Add the items back to the order
        response.items = this.order_items;

        // Grab hold of the order now
        this_sale_order = response;

        // If this is not B2B, add invoice
        if (this.customer_id != 0) {
          response.invoice_number = this._invoice_number;

          // Finally insert a pending invoice for the total of the order if this was not a B2B
          this._invoiceService.createInvoice(
            this_sale_order.customer_id,
            this_sale_order.branch_id,
            new Date().toISOString().substr(0, 10),
            'Invoice',
            (this.totalProduct(this_sale_order.items, 'quantity', 'unit_price') + (this_sale_order.shipping_charges * 1) - (this_sale_order.discount * 1)) * (1 + (this_sale_order.tax / 100)),
            this._invoice_number,
            this_sale_order.id
          ).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                this.reportStatus('Invoice created');
              } else {
                this.reportStatus('Could not create Invoice');
              }
            }
          )

        }

        // Turns out B2B also want invoice so the below line makes it possible
        response.invoice_number = this._invoice_number;

        // Update the sales order to shipped
        this._salesService.updateSale(response.id, response).subscribe(
          updateResponse => {
            if (updateResponse['status'] == 'SUCCESS') {
              this.reportStatus('Order marked as SHIPPED', true);
              // Then generate an Invoice Number if this was not a B2B
              /*if (this.customer_id != 0) {
                this._salesService.generateInvoiceNumber(response.id, response).subscribe(
                  invoiceResponse => {
                    // Finally insert a pending invoice for the total of the order if this was not a B2B
                    this._invoiceService.createInvoice(
                      this_sale_order.customer_id,
                      this_sale_order.branch_id,
                      new Date().toISOString().substr(0, 10),
                      'Invoice',
                      (this.totalProduct(this_sale_order.items, 'quantity', 'unit_price') + (this_sale_order.shipping_charges * 1) - (this_sale_order.discount * 1)) * (1 + (this_sale_order.tax / 100)),
                      invoiceResponse.invoice_number
                    ).subscribe(
                      response => {
                        if (response['status'] == 'SUCCESS') {
                          this.reportStatus('Invoice created');
                        } else {
                          this.reportStatus('Could not create Invoice');
                        }
                      }
                    )
                  }
                );
              }*/
            } else {
              this.reportStatus('Order could NOT be marked as SHIPPED', true);
            }
          }
        );

      }
    );
    // Mark the pieces as sold if this is NOT a B2B
    // UPDATE: Mark them sold also for B2B
    //if (this.customer_id != 0) {
    this.order_items.forEach(
      (piece: Piece) => {
        this._inventoryService.sellPiece(piece).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.reportStatus('Piece ' + response['piece_number'] + ' marked as SOLD');
            } else {
              this.reportStatus('Piece ' + response['piece_number'] + ' could NOT be marked as SOLD');
            }
          }
        );
      }
    );
    //}
    // If this was Branch to branch PO, mark the Purchase order as "SHIPPED", and create a receiving order
    if (this.customer_id == 0) {
      this._poService.getBranchPoByNumber(this.order_number).subscribe(
        (response: PoBranch) => {
          if (response != null && response.id != null) {
            response.status = 'SHIPPED';

            // Update the PO items
            response.transferItems = this.order_items;

            // Call the "ID" "Piece_ID" and 
            response.transferItems.forEach(p => { p.piece_id = p.id; p.length = p.length ? p.length : p.quantity });

            // Then update
            console.log(response);
            this._poService.updateBranchPo(response.po_id, response).subscribe(
              updateResponse => {
                if (updateResponse['status'] == 'SUCCESS') {
                  this.reportStatus('PO ' + response.po_number + ' marked as SHIPPED');
                  // then create receiving
                  this._receivingService.createReceiving(response.po_id, response.notes).subscribe(
                    createResponse => {

                      this._creating = false;

                      if (createResponse['status'] == 'SUCCESS') {
                        this.reportStatus('New Receiving created related to this PO');
                      } else {
                        this.reportStatus('Failed to create Receiving order related to this PO');
                      }
                    },
                    error => {
                      this.reportStatus('Failed to create Receiving order related to this PO');
                      this._creating = false;
                    }
                  );

                } else {
                  this.reportStatus('PO ' + response.po_number + ' could NOT be marked as SHIPPED');
                  this.reportStatus('Failed to create Receiving order related to this PO');
                }

              },
              error => {
                this.reportStatus('PO ' + response.po_number + ' could NOT be marked as SHIPPED');
                this.reportStatus('Failed to create Receiving order related to this PO');
                this._creating = false;
              }
            );
          }
        }
      );
    }

  }

  backToPreparing() {
    this._dialogService.openConfirm(
      {
        title: 'Confirmation request',
        message: 'You are about to move this order back to the preparation stage. Are you sure?'
      }
    ).afterClosed().subscribe(
      response => {
        if (response) {
          this._salesService.getOneSale(this.id).subscribe(
            response => {
              response.status = 'PREPARING';
              delete response.prepared_location_id;

              // Add the items back to the order
              response.items = this.order_items;

              // Update the sales order to PREPARING
              this._salesService.updateSale(response.id, response).subscribe(
                updateResponse => {
                  if (updateResponse['status'] == 'SUCCESS') {
                    this._dialogService.openAlert({ title: 'SUCCESS', message: 'Order marked as PREPARING' });
                    this.router.navigate(['/pda', 'shipping', 'shipOrder']);
                  } else {
                    this._dialogService.openAlert({ title: 'ERROR', message: 'Order could NOT be marked as PREPARING' });
                  }
                }
              );
            }
          );
        }
      }
    );
  }

  totalProduct(data: any[], field1: string, field2: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + (Number.parseFloat(b[field1]) * Number.parseFloat(b[field2])) }, 0);
  }

  printAllFreeTextLabels() {
    this.grouped_items.forEach(
      group => {
        group.pieces.forEach(
          piece => {
            this.printFreeTextLabel(piece.id)
          }
        );
      }
    );
  }

  printFreeTextLabel(piece_id: number) {
    let piece: Piece;

    this._inventoryService.getPiece(piece_id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          piece = response[0];

          // Fill in the gaps from the product view
          this._productService.getOneProduct(piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printService.print(
                  {
                    company_ft: this._notes,
                    collection: piece.collection_name,
                    design: piece.design_name,
                    color: piece.color_name,
                    piece_number: piece.piece_number,
                  }, this._authService.getPrinterId(), 1, 'freetext').subscribe(
                    response => {
                      if (response['status'] == 'SUCCESS') {
                        this._dialogService.openAlert({
                          message: 'Sent to print queue!',
                          title: 'Success'
                        });
                      } else {
                        this._dialogService.openAlert({
                          message: 'Could not send to print queue!',
                          title: 'Failed'
                        });
                      }
                    }
                  );
              } else {
                this._dialogService.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialogService.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/shipping/ship-order-items/ship-order-items.component.ts